import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import FAQSection from './components/FAQSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import UpdatesSection from './components/UpdatesSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <FeaturesSection />
        <TopicsSection />
        <MediaSection />
        <FAQSection />
        <IndexSection />
        <AboutSection />
        <ContactSection />
        <CommentsSection />
        <CardsSection />
        <AppSection />
        <RankingSection />
        <UpdatesSection />
        <CarouselSection />
      </main>
      <Footer />
    </>
  );
}